/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $BankAccountType = {
  type: 'Enum',
} as const;
